import { createFileRoute } from '@tanstack/react-router'
import OrderPlaced from '../../screens/OrderPlaced'

export const Route = createFileRoute('/c/orderplaced')({
  component: RouteComponent,
  validateSearch: (search: { orderId?: string }) => ({
    orderId: search.orderId,
  }),
})

function RouteComponent() {
  return <div><OrderPlaced /></div>
}
